import { ReactNode } from 'react';
import { Stack } from '@mui/material';
import Brand from '@/pages/components/Brand';
import useSSRMediaQuery from '@/hooks/useSSRMediaQuery';

function Hero({ children }: { children: ReactNode }) {
  const isMobile = useSSRMediaQuery('(max-width: 899px)');

  const heightBreakpoints = {
    200: '340vh',
    250: '282vh',
    300: '212vh',
    350: '188vh',
    400: '166vh',
    450: '152vh',
    500: '136vh',
    550: '126vh',
    600: '118vh',
    650: '112vh',
    700: '104vh',
    750: '100vh',
    800: '96vh',
    850: '90vh' // Fallback for larger screens
  };

  const dynamicStyles = Object.entries(heightBreakpoints)
    .sort(([a], [b]) => Number(b) - Number(a)) // Sort breakpoints in descending order
    .reduce(
      (acc, [maxHeight, height]) => ({
        ...acc,
        [`@media screen and (max-height: ${maxHeight}px)`]: {
          height
        }
      }),
      {}
    );

  return (
    <Stack
      data-cy="hero"
      sx={{
        width: '100%',
        height: '85vh',
        justifyContent: 'center',
        backgroundImage: `url('/${isMobile ? 'hero-background-mobile.svg' : 'hero-background.svg'}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom',
        backgroundRepeat: 'no-repeat',
        ...dynamicStyles
      }}
    >
      <Brand />
      {children}
    </Stack>
  );
}

export default Hero;
